import React from 'react';
import { IContainerProps } from './Types';
import './Container.scss';

const Container: React.FC<IContainerProps> = ({ className, children }): JSX.Element => {
  return <div className={`container-wrapper ${className || ''}`}>{children}</div>;
};

export default Container;
